import React, {useRef, useState} from 'react';
import {Box, Button, Dialog, DialogActions, DialogContent, IconButton, Typography} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Alert from '@mui/material/Alert';
import {
    AspectRatioSharp,
    Check,
    Close,
    Flip,
    ImageAspectRatioSharp,
    RotateLeft,
    RotateRight
} from '@mui/icons-material';
import pdfIcon from '../assets/img/pdf.svg';
import Strings from "../assets/strings";
import {hasModule} from "../helpers";
import {MODULO_USUARIO} from "../helpers/CONSTANTES";
import openAdjunto from "../helpers/openAdjunto";
// import DefaultImgEmp from "../assets/img/defaultAvatar_empresa.jpg";
// import NoImg from "../assets/img/defaultAvatar.jpg";
import {Cropper, CropperRef} from 'react-advanced-cropper'
import 'react-advanced-cropper/dist/style.css';
import 'react-advanced-cropper/dist/themes/bubble.css';


const useStyles = makeStyles(theme => ({
    groupImg:{
        "display": "flex",
        overflow: "hidden",
        "&>div":{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "border": "1px solid #e9ecef",
            "position": "relative",
            "width": "105px",
            "height": "105px",
            "margin": "5px",
            "& img":{
                width:"100%",
            },
            "& .delete":{
                "fontSize": "21px",
                "position": "absolute",
                "right": "0",
                "top": "0",
                "cursor": "pointer",
                "color": "#f64a4a",
                "background": "#fff",
                "width": "40px",
                "height": "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1,
                "textAlign": "center",
                "WebkitTransition": "opacity .2s",
                "transition": "opacity .2s",
            },
            "&.deleted img":{
                opacity: .3,
            },
            "&.pdf img":{
                maxWidth: 66,
            }

        }
    },
    dialogContent:{
        padding: "3px !important",

    },
    dialogActions:{
        display:"flex",
        justifyContent:"space-between"
    }
}));


type TProps = {
    permitirDocumentos?: boolean,
    adjuntos?: any[],
    onChange:any,
    changeRadio?: boolean
    accept?: string
}
export default function AddAdjuntos({permitirDocumentos= true, adjuntos=[], onChange, changeRadio = true,accept="image/gif, image/jpeg, image/png, application/pdf"}:TProps){
    const classes = useStyles();

    const [img, setImg] = useState<string|null>(null);
    const [error, setError] = useState<string|null>(null);
    const [loading, setLoading] = useState(false);
    const [showAddForm, setShowAddForm] = useState(false);
    const [aspectRatioSq, setAspectRatioSq] = useState(true);
    const cropperRef = useRef<CropperRef>(null);

    const showModal = () => {
        setShowAddForm(true)
    }
    const closeModal = () => {
        setLoading(false)
        setShowAddForm(false)
    }
    const handleChange = (e:  React.ChangeEvent<HTMLInputElement>) => {
        setError(null);
        let file = e.target.files ? e.target.files[0] : undefined;

        if (!file) return false;
        if(file.type.indexOf("image") === -1 && file.type.indexOf("pdf") === -1) return setError(Strings.archivoNoPermitidoMsj)

        if(file.type.indexOf("pdf") !== -1 && file.size > 2000000) return setError(Strings.archivoExcedeMsj+ ", 2MB!");

        const reader = new FileReader();
        reader.onload = () => {
            if(file?.type.indexOf("image") !== -1){
                setImg(reader.result as string);
                showModal()
            }else{
                let adj = [...adjuntos];
                adj.push({ extension: "pdf", base64: reader.result})
                onChange(adj);
            }
        };
        reader.readAsDataURL(file);

    }
    const cropImage = () => {
        if(loading) return false;

        setLoading(true)

        if (cropperRef.current) {

            let adj = [...adjuntos];
            let base64 = cropperRef.current.getCanvas({fillColor:'#ffffff'})?.toDataURL('image/jpeg', 0.8)
            adj.push({ extension: "jpeg", base64});

            onChange(adj);
            closeModal();

        }



    }
    const delAdjunto = (index:number)  =>{


        let adj = [...adjuntos];

        if (adj[index]?.base64 === null){
            adj = adj.map((item, i)=>{
                if(i === index){
                    return {
                        ...item,
                        base64: "-1"
                    }
                }
                return item;
            })
        } else if (adj[index]?.base64 === "-1") {
            adj = adj.map((item, i)=>{
                if(i === index){
                    return {
                        ...item,
                        base64: null
                    }
                }
                return item;
            })
        }else{
            adj.splice(index, 1)
        }
        onChange(adj);



        // if(src && src.toString().length < 100 && src !== -1){
        //     setDeleted(src);
        //     onChange(-1)
        // }else{
        //     onChange(deleted)
        // }
    }

    const flip = (horizontal: boolean, vertical: boolean) => {
        if (cropperRef.current) {
            cropperRef.current?.flipImage(horizontal, vertical);
        }
    };
    const rotate = (angle: number) => {
        if (cropperRef.current) {
            cropperRef.current?.rotateImage(angle);
        }
    };


    if(hasModule(MODULO_USUARIO.documentos) || permitirDocumentos){
        return  <>
            <div className="customCard">
                <Box className={"title"} p={"0 10px !important" } sx={{width: 'calc(100% - 4px) !important'}}>
                    <Box color={"primary.main"} fontSize={14}>{Strings.adjuntos}</Box>
                    <Button size={"small"} component={"label"}  color="primary" disabled={adjuntos?.length >= 5 }>
                        {Strings.agregar}
                        <input type="file" style={{display:"none"}} onChange={handleChange} accept={accept}/>

                    </Button>
                </Box>
                {!adjuntos.length &&
                    <Typography mt={"-3px"} mb={1} align={"center"} color={"gray"}>
                        Agregar fotos de cédula y cualquier otro documento de interés.
                    </Typography>
                }
                {!!error && <Alert onClose={() => setError(null)} severity="warning">{error}</Alert>}

                    <div className={classes.groupImg}>
                        {adjuntos?.length > 0 && adjuntos.map((adjunto, i) =>
                            <div key={i} className={(adjunto.extension === "pdf" ? 'pdf' : 'img') + (adjunto.base64 === "-1" ? ' deleted' : '') }>
                                <div className="delete" onClick={() => delAdjunto(i)}>{adjunto.base64 === "-1" ? <Check color={"primary"}/> : <Close/>}</div>
                                    <img
                                        onClick={()=>openAdjunto(adjunto.path ? adjunto.path.replace("-small", "") : adjunto.base64)}
                                        src={adjunto.extension === "pdf" ? pdfIcon : (adjunto.path ? adjunto.path : adjunto.base64)} alt=""  />
                            </div>)
                        }
                    </div>

            </div>
            <Dialog open={Boolean(showAddForm)} onClose={closeModal}>
                <DialogContent className={classes.dialogContent}>
                    <Cropper
                        ref={cropperRef}
                        style={{ height: 400, width: '100%' }}
                        src={img}
                        stencilProps={{
                            grid: true,
                            aspectRatio: aspectRatioSq ? 1/1 : undefined,
                            movable: true,
                            resizable: true,
                        }}
                    />
                </DialogContent>

                <DialogActions className={classes.dialogActions}>

                    {changeRadio &&
                        <IconButton size={"small"} color="primary" onClick={() => setAspectRatioSq(!aspectRatioSq)}>
                            {aspectRatioSq ?(<AspectRatioSharp fontSize={"small"} />):(<ImageAspectRatioSharp fontSize={"small"} color={"secondary"}/>)}
                        </IconButton>
                    }
                    <IconButton size={"small"} color="primary" onClick={() => flip(true, false)}>
                        <Flip fontSize={"small"}/>
                    </IconButton>

                    <IconButton size={"small"} color="primary" onClick={() => flip(false, true)}>
                        <Flip fontSize={"small"} sx={{rotate: "90deg"}}/>
                    </IconButton>

                    <IconButton disabled={loading} sx={{backgroundColor:(theme)=> theme.palette.primary.main +" !important"}} onClick={!loading ? cropImage : undefined}>
                        <Check sx={{color:"white"}}/>
                    </IconButton>


                    <IconButton size={"small"} color="primary" onClick={() => rotate(90)}>
                        <RotateRight fontSize={"small"}/>
                    </IconButton>
                    <IconButton size={"small"} color="primary" onClick={() => rotate(-90)}>
                        <RotateLeft fontSize={"small"}/>
                    </IconButton>

                    <IconButton size={"small"} color="error" onClick={closeModal}>
                        <Close fontSize={"small"}/>
                    </IconButton>

                    {/*<Button color="primary" onClick={closeModal}>{Strings.cerrar}</Button>*/}
                    {/*<Button*/}
                    {/*    color="primary"*/}
                    {/*    disabled={loading}*/}
                    {/*    onClick={!loading ? getCropData : undefined} >*/}
                    {/*    {loading ? Strings.cargando : Strings.agregar}*/}
                    {/*</Button>*/}
                </DialogActions>

            </Dialog>
        </>
    }
    return (
       <></>
    );
}
